module.exports = __webpack_public_path__ + "img/social4.15b37098.png";